import React from 'react';
import { ThemeContextProvider } from '@qler-view/shared_lib/src/shared/lib/providers/ThemeProviderContext.tsx';
import { opsLightTheme, opsDarkTheme } from '../utils/opsTheme';
import type { ReactNode } from 'react';

interface OpsThemeProviderProps {
  children: ReactNode;
}

export const FacilityThemeProvider: React.FC<OpsThemeProviderProps> = ({
  children,
}) => {
  return (
    <ThemeContextProvider lightTheme={opsLightTheme} darkTheme={opsDarkTheme}>
      {children}
    </ThemeContextProvider>
  );
};
